import { render, staticRenderFns } from "./AnimationSettings.vue?vue&type=template&id=4e3bbce8&lang=pug"
import script from "./AnimationSettings.vue?vue&type=script&lang=js"
export * from "./AnimationSettings.vue?vue&type=script&lang=js"
import style0 from "./AnimationSettings.vue?vue&type=style&index=0&id=4e3bbce8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports